import { Step } from '@repo/common';

import { setWorkflowAction } from '@/providers/app-provider/actions';
import { useAppContext } from '@/providers/app-provider/context';
import { postSubmitHandled } from '@/services/rivaas-api';
import { mapBffErrorCodeToFailReason } from '@/utils/bff-error-mapping';
import { nextWorkflowFromSubmit } from '@/utils/step-workflow';

export function useContinueOnThisDevice() {
  const {
    dispatch,
    state: { customerData },
  } = useAppContext();

  async function continueOnThisDevice() {
    const data = await postSubmitHandled(undefined, { clearRedirectToken: true, skipSteps: 1 });

    if (data.error) {
      const workflowBase =
        data.nextStep.step === 'fail'
          ? nextWorkflowFromSubmit(data, {
              unverifiedUrl: customerData?.redirect?.unverifiedUrl,
              verifiedUrl: customerData?.redirect?.verifiedUrl,
            })
          : null;

      if (workflowBase && workflowBase.nextStep.value === Step.FAIL) {
        dispatch(
          setWorkflowAction({
            ...workflowBase,
            nextStep: {
              ...workflowBase.nextStep,
              failReason: mapBffErrorCodeToFailReason(data.error.code),
            },
          }),
        );
      }

      // eslint-disable-next-line no-console
      console.error('Continue on this device failed:', data.error);

      return;
    }

    const workflow = nextWorkflowFromSubmit(data, {
      unverifiedUrl: customerData?.redirect?.unverifiedUrl,
      verifiedUrl: customerData?.redirect?.verifiedUrl,
    });

    if (workflow) {
      dispatch(setWorkflowAction(workflow));
    }
  }

  return { continueOnThisDevice };
}
